import { convertSectionsToSidePanel } from "components/MainSectionTemplate/SidePanelSection/convertSectionsToSidePanel";
import { SidePanelDetailSectionTemplate } from "components/MainSectionTemplate/SidePanelSection/SidePanelDetailSectionTemplate";
import { groundTransportSections } from "groundTransport/groundTransportSections";
import { useGroundTransportDetail } from "groundTransport/useGroundTransportDetail";
import React from "react";
import { SidePanelLinkedShowList } from "../SidePanelLinkedShowList";

interface GroundSidePanelDetailsProps {
  groundTransportSidePanelData: server.dto.GroundTransportSidePanelData
  onChange: () => void
}

export const GroundSidePanelDetails = (props: GroundSidePanelDetailsProps) => {
  const {
    state,
    hasDriver,
    hasMap,
    onValueChanged,
    onSuccessfulUpdate,
    getUpdateGroundTransportInstruction,
  } = useGroundTransportDetail(
    props.groundTransportSidePanelData.groundTransport,
    props.groundTransportSidePanelData.travellers,
    () => { },
    () => { },
    () => { }
  );

  const onSuccessfulUpdateSidePanel = async (key: string, value: any) => {
    await onSuccessfulUpdate(key, value);
    props.onChange();
  }

  const sections = groundTransportSections(state, props.groundTransportSidePanelData.linkedShows, getUpdateGroundTransportInstruction, hasDriver, hasMap, () => null);

  return <SidePanelDetailSectionTemplate
    isInPageEditable={props.groundTransportSidePanelData.groundTransport.permissions.canModify}
    onValueChanged={onValueChanged}
    onSuccessfulUpdate={onSuccessfulUpdateSidePanel}
    fields={convertSectionsToSidePanel(sections)}
    additionalContent={<>
      <SidePanelLinkedShowList linkedShows={props.groundTransportSidePanelData.linkedShows} />
    </>}
  />
}